module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-light-300.3d8af27a.woff2";